import React, { useRef, useEffect, useState } from 'react';
import heart_path from 'heart_path.svg';
import ReactSVG from 'react-svg';
import axios from 'axios';
import ReactGA from 'react-ga';
import { toast } from 'react-toastify';
import { disableBodyScroll } from 'body-scroll-lock';
import default_listing_image from 'default_listing_image.svg';
import moment from 'moment';
import { handleHeartAnimation } from '../../utils/handleHeartAnimation';
import FavoriteSuccessBanner from '../CustomToast/FavoriteSuccessBanner';

export default function MobileEventActiveMarker({ item, userData }) {
  // console.log(item);
  const heartRef = useRef(null);

  const eventImage =
    item.medium_featured_image_url ||
    item.small_featured_image_url ||
    item.featured_image.image_url;

  const [favorited, setFavorited] = useState(false);
  useEffect(() => {
    if (item.favorited) {
      setFavorited(true);
    }
  }, [item]);

  const [favoriteRoute, setFavoriteRoute] = useState(null);
  useEffect(() => {
    setFavoriteRoute(window.Routes.favorite_event_path({ id: item.id }));
  }, [item.id]);

  const handleFavorited = () => {
    const tokenElement = document.querySelector('[name=csrf-token]');
    if (userData && userData.user && userData.user.id) {
      handleHeartAnimation({ ref: heartRef, favorited });
      axios
        .patch(favoriteRoute, null, {
          headers: {
            'X-CSRF-Token': tokenElement ? tokenElement.content : '',
            Accept: 'application/json',
          },
        })
        .then(res => {
          // If the event is NOT favorited yet, set favorited
          toast.dismiss();
          if (!favorited)
            toast(<FavoriteSuccessBanner favorited type={item} />);
          else toast(<FavoriteSuccessBanner type={item} />);

          if (res.status === 200) setFavorited(!favorited);
        })
        .catch(err => {
          console.error(err);
          if (err.response.status === 401) {
            window.location.pathname = window.Routes.login_path();
          }
        });
    } else {
      const modal = document.querySelector('#popup-modal');
      modal.classList.remove('fadeOut');
      modal.classList.remove('hidden');
      modal.classList.add('fadeIn');
      disableBodyScroll(modal);
    }
  };

  const parsedEventDate = item.start_date.includes(' ')
    ? item.start_date.replace(/-/g, '/')
    : item.start_date;

  return (
    <>
      <button
        aria-label="Toggle Favorite"
        name="Toggle Favorite"
        ref={heartRef}
        type="button"
        className={`card-heart ${item.favorited ? 'favorited' : ''}`}
        onClick={handleFavorited}
      >
        <ReactSVG src={heart_path} className="heart-icon" />
      </button>

      <a
        href={`/events/${item.slug}/${item.id}`}
        onClick={() => {
          if (window.location.pathname === '/events') {
            ReactGA.event({
              category: 'Event',
              action: 'Viewed Event from Search',
            });
          }
        }}
        className="mobile-event-active-card"
      >
        <h3 className="event-title">{item.title}</h3>
        <h3 className="event-date">
          {/* Date Format: "2/18/2020" */}
          {moment(new Date(parsedEventDate).toLocaleDateString(), 'MM/DD/YYYY')
            .add(1, 'd')
            .format('MMM D')}
        </h3>
        <h3 className="event-info">
          <span className="category">{item.category.replace(/_/g, ' ')}</span>
          <span className="time">
            {' '}
            • {!item.all_day_event ? item.start_time : 'All Day'}
          </span>
        </h3>
        <img
          className="event-image"
          src={eventImage}
          alt={item.title}
          title={item.title}
        />
      </a>
    </>
  );
}
